export default __webpack_public_path__ + "static/media/bigyama_dp.aa7c6d7b.jpg";